import { createRouter, createWebHistory } from "vue-router";
import MainLayout from "../layouts/MainLayout.vue";               // admin
import FrontendLayout from "../views/Frontend/layouts/Layout.vue"; 
import Dashboard from "../views/Dashboard.vue";
import Home from "../views/Frontend/Home.vue";

import SupplierList  from "@/views/Suppliers/SupplierList.vue";
import AllReviews from "@/views/Suppliers/AllReviews.vue";
import AdminSupplierProfile from "@/views/Suppliers/Profile.vue";
import ReviewDetail from "@/views/Suppliers/ReviewDetails.vue";
import AdminLogin from "@/views/Auth/Login.vue"; // adjust path to wherever you saved it

///frontend
import Signup from "@/views/Frontend/Auth/Signup.vue";
import MyProfile from "@/views/Frontend/suppliers/MyProfile.vue";
import SearchNetwork from "@/views/Frontend/suppliers/SearchNetwork.vue";
import SupplierProfile from "@/views/Frontend/suppliers/SupplierProfile.vue";
import SupplierLogin from "@/views/Frontend/Auth/Login.vue";
import ConversationsPage from "@/views/Frontend/suppliers/Chats.vue";
import EditProfile from "@/views/Frontend/suppliers/EditInfo.vue";



const routes = [
  {
    path: "/login",
    name: "SupplierLogin",
    component: SupplierLogin
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup
  },
  {
    path: "/admin/login",
    name: "AdminLogin",
    component: AdminLogin,
  },
  {
    path: "/",
    component: FrontendLayout,
    children: [
      { path: "", name: "Home", component: Home },

      {
        path: "/profile",
        name: "Profile",
        component: MyProfile,
      },
      {
        path: "/search",
        name: "SearchNetwork",
        component: SearchNetwork,
      },
      {
        path: '/supplier/:external_id',
        name: 'SupplierProfile',
        component: SupplierProfile,
        props: true,
      },
      {
        path: "/conversations",
        name: "Conversations",
        component: ConversationsPage,
      },
      {
        path: "/edit-profile",
        name: "EditProfile",
        component: EditProfile,
      }

    ],
  },

  {
    path: "/main",
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        redirect: "dashboard",
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },

      {
        path: "supplier",
        children: [
          {
            path: "list",
            name: "SupplierList",
            component: SupplierList,
          },
          {
            path: '/admin/suppliers/:id/profile',
            name: 'AdminSupplierProfile',
            component: AdminSupplierProfile,
          },
          {
            path: '/admin/suppliers/reviews',
            name: 'AllReviews',
            component: AllReviews,
          },
          {
            path: '/reviews/:id',
            name: 'ReviewDetail',
            component: ReviewDetail,
          }
        ]
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const isAuthenticated = !!localStorage.getItem('admin_token')

  if (requiresAuth && !isAuthenticated) {
    next({ name: 'AdminLogin', query: { redirect: to.fullPath } })
    return
  }
  if (to.name === 'AdminLogin' && isAuthenticated) {
    next({ name: 'Dashboard' })
    return
  }

  next()
})

export default router;